import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportStockLedgerService extends GenericService {
  constructor() {
    super('/reports/stock_ledger', axiosInstance);
  }
}

export default new ReportStockLedgerService(); 